import { validatorPossui2Dependentes65anos } from './funcoesAuxiliaresZSM';

export class CorrenteCadastroZSM {
    constructor(dependentes, parentesco, categorias,valoresForm,idadeAssociado) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.idadeAssociado = idadeAssociado;
    }
   
    possui6Dependentes() {
        const qtdDependentesTotais = this.dependentes.length;

        if (qtdDependentesTotais === 6) {
            this.arrayMsgsErro.push('Este plano permite apenas 6 dependentes.');
        }

        return this;
    }
  
    parentescoComAdicionalMais65(){
        if(validatorPossui2Dependentes65anos(this.dependentes,this.valoresForm,this.idadeAssociado)){
            this.arrayMsgsErro.push('Este plano permite apenas 2 dependentes com idade maior ou igual a 65 anos. Caso a idade do titular do plano seja maior ou igual a 65, este valor é reduzido para apenas 1 dependente.');
        }

        return this;
    }
}